import DocumentSvg from './DocumentIcon.svg?react'

import styles from '@/pages/app/Usage/styles.module.scss'

const DocumentIcon = () => <DocumentSvg className={styles.icon} />

export default DocumentIcon
